/* PDP customer reviews — slider behaviour for prev/next, dots, and active state. */
(function () {
  'use strict';

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function setupSection(root) {
    if (root.dataset.pdpCrInit === 'true') return;
    root.dataset.pdpCrInit = 'true';

    var track = root.querySelector('[data-pdp-cr-track]');
    var prevBtn = root.querySelector('[data-pdp-cr-prev]');
    var nextBtn = root.querySelector('[data-pdp-cr-next]');
    var dotsContainer = root.querySelector('[data-pdp-cr-dots]');

    if (!track || !prevBtn || !nextBtn || !dotsContainer) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.pdp-cr__card'));
    if (!cards.length) {
      hideControls();
      return;
    }

    function getVisibleCount() {
      var trackWidth = track.clientWidth;
      var card = cards[0];
      if (!card) return 1;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var cardWidth = card.getBoundingClientRect().width;
      if (cardWidth <= 0) return 1;
      var count = Math.round((trackWidth + gap) / (cardWidth + gap));
      return clamp(count, 1, cards.length);
    }

    function getPageCount() {
      var visible = getVisibleCount();
      return Math.max(1, cards.length - visible + 1);
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      var pageCount = getPageCount();
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-cr__dot';
        dot.setAttribute('data-pdp-cr-dot', String(i));
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dotsContainer.appendChild(dot);
      }
    }

    function getCardOffset(card) {
      // Distance of card left edge from track left edge, factoring in current scroll.
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function getCurrentIndex() {
      var scrollLeft = track.scrollLeft;
      var minDelta = Infinity;
      var index = 0;
      for (var i = 0; i < cards.length; i++) {
        var delta = Math.abs(getCardOffset(cards[i]) - scrollLeft);
        if (delta < minDelta) {
          minDelta = delta;
          index = i;
        }
      }
      return index;
    }

    function updateActiveStates() {
      var pageCount = getPageCount();
      var current = clamp(getCurrentIndex(), 0, pageCount - 1);
      var dots = dotsContainer.querySelectorAll('.pdp-cr__dot');
      dots.forEach(function (dot, i) {
        if (i === current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      // Disable arrows at ends — track scrollLeft tolerance for sub-pixel.
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollToIndex(index) {
      var pageCount = getPageCount();
      var clamped = clamp(index, 0, pageCount - 1);
      var target = cards[clamped];
      if (!target) return;
      track.scrollTo({ left: getCardOffset(target), behavior: 'smooth' });
    }

    function hideControls() {
      var controls = root.querySelector('[data-pdp-cr-controls]');
      if (controls) controls.style.display = 'none';
    }

    function maybeHideControlsForFewCards() {
      var pageCount = getPageCount();
      var controls = root.querySelector('[data-pdp-cr-controls]');
      if (!controls) return;
      controls.style.display = pageCount <= 1 ? 'none' : '';
    }

    prevBtn.addEventListener('click', function () {
      scrollToIndex(getCurrentIndex() - 1);
    });

    nextBtn.addEventListener('click', function () {
      scrollToIndex(getCurrentIndex() + 1);
    });

    dotsContainer.addEventListener('click', function (e) {
      var target = e.target;
      if (!(target instanceof Element)) return;
      var dot = target.closest('[data-pdp-cr-dot]');
      if (!dot) return;
      var i = parseInt(dot.getAttribute('data-pdp-cr-dot'), 10);
      if (!isNaN(i)) scrollToIndex(i);
    });

    var scrollRaf = null;
    track.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateActiveStates);
      },
      { passive: true }
    );

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildDots();
        maybeHideControlsForFewCards();
        updateActiveStates();
      }, 120);
    });

    buildDots();
    maybeHideControlsForFewCards();
    updateActiveStates();
  }

  function init() {
    var sections = document.querySelectorAll('[data-pdp-cr]');
    sections.forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector('[data-pdp-cr]')
      : null;
    if (section) setupSection(section);
  });
})();
